export default "__VITE_ASSET__101187e7__"